// controllers/weight_logic_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'otherField'];

  connect() {
    this.toggle();
  }

  toggle() {
    const isOther = this.selectTarget.value === 'other';
    this.otherFieldTarget.hidden = !isOther;
  }
}
